import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/questions/consumption_categories', data);
  return response.data.data;
}
async function destroy(question_id) {
  let response = await axiosAuth.delete('/questions/consumption_categories/' + question_id);
  return response.data.data;
}

export default {
  store,
  destroy,
};
